module.exports = __webpack_public_path__ + "img/loriot-packet-forwarder-large-light.300fdb13.png";